<template>
  <div>
    <v-layout>
      <v-dialog
        v-model="show"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        persistent
        max-width="600px"
      >
        <v-toolbar color="blue darken-2" dark>
          <v-btn icon dark @click.stop="show=false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Reports</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-list two-line subheader>
            <v-subheader inset>Sponsors</v-subheader>

            <v-list-tile
              v-for="item in items"
              :key="item.title"
              avatar
            >
              <v-list-tile-avatar @click="report(item.action)">
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content @click="report(item.action)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-progress-circular
                  v-show="loading && item.action === 'checkIn'"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <v-btn v-show="checkinDownload && item.action === 'checkIn'" fab dark small color="primary" :href="fileName" target="_blank">
                  <v-icon dark>mdi-download</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>

            <v-divider inset></v-divider>

            <v-subheader inset>Accounting</v-subheader>

            <v-list-tile
              v-for="item in items2"
              :key="item.title"
              avatar
              @click="report(item.action)"
            >
              <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'
import XLSX from 'xlsx'

export default {
  props: ['visible', 'currentYear'],

  data () {
    return {
      rows: [],
      items: [
        { icon: 'mdi-account-group', iconClass: 'grey lighten-1 white--text', title: 'Sponsor Report', subtitle: 'Report of all Sponsors', action: 'sponsor' }
      ],
      items2: [
        { icon: 'mdi-receipt-text-outline', iconClass: 'blue white--text', title: 'Invoice Report', subtitle: 'Report of all Invoices', action: 'invoice' },
        { icon: 'mdi-cash', iconClass: 'amber white--text', title: 'Payment Report', subtitle: 'Report of all payments', action: 'payment' }
      ],
      loading: false,
      checkinDownload: false,
      fileName: process.env.API_URL + '/attachments/checkin.pdf',
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    report (report) {
      this.rows = []

      if (report === 'payment') {
        this.getPayments(0, 'Sponsor Payment Report')
      } else if (report === 'invoice') {
        this.getInvoices(0, 'Sponsor Invoice Report')
      } else if (report === 'sponsor') {
        this.getSponsors('Sponsor Report')
      } else if (report === 'sponsor1') {
        this.getSponsors1('Sponsor Report')
      } else if (report === 'sponsor2') {
        this.getSponsors2('Sponsor Report')
      }
    },

    async getSponsors (title) {
      try {
        await Api().get('sponsors')
          .then(res => {
            const sponsorList = res.data
            console.log('NEW', sponsorList)

            let row = {}
            for (let i in sponsorList) {
              row.name = sponsorList[i].name
              row.address = sponsorList[i].address
              row.city = sponsorList[i].city
              row.state = sponsorList[i].state
              row.zip = sponsorList[i].zip
              row.fullName = sponsorList[i].SponsorContacts[0].fullName
              row.email = sponsorList[i].SponsorContacts[0].email
              row.phone = sponsorList[i].SponsorContacts[0].phone
              // // row.confirm = sponsorList[i].SponsorDetails[0].confirm
              // // row.paid = sponsorList[i].SponsorDetails[0].paid
              let rep = ''
              if (sponsorList[i].SponsorDetails.length > 0) {
                row.levelName = sponsorList[i].SponsorDetails[0].name
                row.sponsorNotes = sponsorList[i].SponsorDetails[0].sponsorNotes
                row.arenaSignage = JSON.parse(sponsorList[i].SponsorDetails[0].arenaSignage)
                row.arenaNotes = sponsorList[i].SponsorDetails[0].arenaNotes
                row.bannerSignage = JSON.parse(sponsorList[i].SponsorDetails[0].bannerSignage)
                row.bannerNotes = sponsorList[i].SponsorDetails[0].bannerNotes
                row.other = JSON.parse(sponsorList[i].SponsorDetails[0].other)
                row.otherNotes = sponsorList[i].SponsorDetails[0].otherNotes

                row.a1 = ''
                row.a2 = ''
                row.a3 = ''
                row.a4 = ''
                row.a5 = ''
                row.a6 = ''
                row.a7 = ''
                row.a8 = ''
                row.a9 = ''
                row.a10 = ''
                row.a11 = ''
                row.a12 = ''
                row.a13 = ''
                row.a14 = ''

                row.b1 = ''
                row.b2 = ''
                row.b3 = ''
                row.b4 = ''
                row.b5 = ''
                row.b6 = ''
                row.b7 = ''
                row.b8 = ''
                row.b9 = ''
                row.b10 = ''
                row.b11 = ''
                row.b12 = ''
                row.b13 = ''
                row.b14 = ''
                row.b15 = ''
                row.b16 = ''
                row.b17 = ''
                row.b18 = ''
                row.b19 = ''

                row.o1 = ''
                row.o2 = ''
                row.o3 = ''
                row.o4 = ''
                row.o5 = ''
                row.o6 = ''
                row.o7 = ''

                if (row.arenaSignage.length > 0) {
                  for (let j in row.arenaSignage) {
                    console.log(row.arenaSignage[j])
                    if (row.arenaSignage[j] === 'Above Chutes') {
                      row.a1 = 'Above Chutes'
                    } else if (row.arenaSignage[j] === 'Center Return') {
                      row.a2 = 'Center Return'
                    } else if (row.arenaSignage[j] === 'Chute - inside') {
                      row.a3 = 'Chute - inside'
                    } else if (row.arenaSignage[j] === 'Chute - outside') {
                      row.a4 = 'Chute - outside'
                    } else if (row.arenaSignage[j] === 'Grand Entry') {
                      row.a5 = 'Grand Entry'
                    } else if (row.arenaSignage[j] === 'Header Box') {
                      row.a6 = 'Header Box'
                    } else if (row.arenaSignage[j] === 'Heeler Box') {
                      row.a7 = 'Heeler Box'
                    } else if (row.arenaSignage[j] === 'Man Door') {
                      row.a8 = 'Man Door'
                    } else if (row.arenaSignage[j] === 'Outgate') {
                      row.a9 = 'Outgate'
                    } else if (row.arenaSignage[j] === 'Paddock Wall') {
                      row.a10 = 'Paddock Wall'
                    } else if (row.arenaSignage[j] === 'Roping Box') {
                      row.a11 = 'Roping Box'
                    } else if (row.arenaSignage[j] === 'Section F front') {
                      row.a12 = 'Section F front'
                    } else if (row.arenaSignage[j] === 'Section G front') {
                      row.a13 = 'Section G front'
                    } else if (row.arenaSignage[j] === 'Tack Room Wall') {
                      row.a14 = 'Tack Room Wall'
                    }
                  }
                }

                if (row.bannerSignage.length > 0) {
                  for (let j in row.bannerSignage) {
                    console.log(row.bannerSignage[j])
                    if (row.bannerSignage[j] === 'Gate Entrances (5)') {
                      row.b1 = 'Gate Entrances (5)'
                    } else if (row.bannerSignage[j] === 'Gold Spur Trailer Fence') {
                      row.b2 = 'Gold Spur Trailer Fence'
                    } else if (row.bannerSignage[j] === 'Hospitality Tent') {
                      row.b3 = 'Hospitality Tent'
                    } else if (row.bannerSignage[j] === 'Main Entrance Fence') {
                      row.b5 = 'Main Entrance Fence'
                    } else if (row.bannerSignage[j] === 'Outpost Tent') {
                      row.b6 = 'Outpost Tent'
                    } else if (row.bannerSignage[j] === 'Paddock Top - inside') {
                      row.b7 = 'Paddock Top - inside'
                    } else if (row.bannerSignage[j] === 'Paddock Top - outside') {
                      row.b8 = 'Paddock Top - outside'
                    } else if (row.bannerSignage[j] === 'Parking Lot') {
                      row.b9 = 'Parking Lot'
                    } else if (row.bannerSignage[j] === 'Section F Bar') {
                      row.b10 = 'Section F Bar'
                    } else if (row.bannerSignage[j] === 'Section F Top - inside') {
                      row.b11 = 'Section F Top - inside'
                    } else if (row.bannerSignage[j] === 'Section F Top - outside') {
                      row.b12 = 'Section F Top - outside'
                    } else if (row.bannerSignage[j] === 'Section G Bar') {
                      row.b13 = 'Section G Bar'
                    } else if (row.bannerSignage[j] === 'Section G Top - inside') {
                      row.b14 = 'Section G Top - inside'
                    } else if (row.bannerSignage[j] === 'Section G Top - outside') {
                      row.b15 = 'Section G Top - outside'
                    } else if (row.bannerSignage[j] === 'Shuttles') {
                      row.b16 = 'Shuttles'
                    } else if (row.bannerSignage[j] === 'Tack Room Fence') {
                      row.b17 = 'Tack Room Fence'
                    } else if (row.bannerSignage[j] === 'Trading Post Tent') {
                      row.b18 = 'Trading Post Tent'
                    } else if (row.bannerSignage[j] === 'Warm Up Arena') {
                      row.b19 = 'Warm Up Arena'
                    }
                  }
                }

                if (row.other.length > 0) {
                  for (let j in row.other) {
                    console.log(row.other[j])
                    if (row.other[j] === 'Commercial') {
                      row.o1 = 'Commercial'
                    } else if (row.other[j] === 'Flag') {
                      row.o2 = 'Flag'
                    } else if (row.other[j] === 'PA Announcement') {
                      row.o3 = 'PA Announcement'
                    } else if (row.other[j] === 'Program Ad - full page') {
                      row.o4 = 'Program Ad - full page'
                    } else if (row.other[j] === 'Program Ad - half page') {
                      row.o5 = 'Program Ad - half page'
                    } else if (row.other[j] === 'Scoreboard logo') {
                      row.o6 = 'Scoreboard logo'
                    } else if (row.other[j] === 'Social Media Recognition') {
                      row.o7 = 'Social Media Recognition'
                    }
                  }
                }

                if (sponsorList[i].SponsorDetails[0].User) {
                  let user = sponsorList[i].SponsorDetails[0].User
                  rep = user.fullName
                }

                if (sponsorList[i].SponsorDetails[0].SponsorLevels.length > 0) {
                  const levels = sponsorList[i].SponsorDetails[0].SponsorLevels
                  let totprice = 0
                  let tottrade = 0

                  for (let j in levels) {
                    let price = Number(levels[j].price)
                    let trade = Number(levels[j].trade)

                    totprice += price
                    tottrade += trade
                  }
                  row.price = totprice
                  row.trade = tottrade
                }
              } else {
                row.levelName = ''
              }

              row.rep = rep

              this.rows.push(row)
              row = {}
            }

            let printSponsors = this.rows.map(a => ({
              'Name': a.name,
              'Address': a.address,
              'City': a.city,
              'State': a.state,
              'Zip': a.zip,
              'Contact': a.fullName,
              'Email': a.email,
              'Phone': a.phone,
              // 'Confirm': a.confirm,
              // 'Paid': a.paid,
              'Level': a.levelName,
              'Rep': a.rep,
              'Sponsor Notes': a.sponsorNotes,
              // 'Arena Signage': a.arenaSignage,
              'Arena 1': a.a1,
              'Arena 2': a.a2,
              'Arena 3': a.a3,
              'Arena 4': a.a4,
              'Arena 5': a.a5,
              'Arena 6': a.a6,
              'Arena 7': a.a7,
              'Arena 8': a.a8,
              'Arena 9': a.a9,
              'Arena 10': a.a10,
              'Arena 11': a.a11,
              'Arena 12': a.a12,
              'Arena 13': a.a13,
              'Arena 14': a.a14,
              'Arena Notes': a.arenaNotes,
              'Banner 1': a.b1,
              'Banner 2': a.b2,
              'Banner 3': a.b3,
              'Banner 4': a.b5,
              'Banner 5': a.b6,
              'Banner 6': a.b7,
              'Banner 7': a.b8,
              'Banner 8': a.b9,
              'Banner 9': a.b10,
              'Banner 10': a.b11,
              'Banner 11': a.b12,
              'Banner 12': a.b13,
              'Banner 13': a.b14,
              'Banner 14': a.b15,
              'Banner 15': a.b16,
              'Banner 16': a.b17,
              'Banner 17': a.b18,
              'Banner 18': a.b19,
              'Banner Notes': a.bannerNotes,
              'Other 1': a.o1,
              'Other 2': a.o2,
              'Other 3': a.o3,
              'Other 4': a.o4,
              'Other 5': a.o5,
              'Other 6': a.o6,
              'Other 7': a.o7,
              'Other Notew': a.otherNotes,
              // 'Concert Cash': a.Concert,
              // 'Rodeo Gold Buckle Cash': a.RodeoGoldBuckle,
              // 'Rodeo Gold Buckle Trade': a.RodeoGoldBuckletrade,
              // 'Rodeo Year-Round Partnership Cash': a.RodeoYearRoundPartnership,
              // 'Rodeo Year-Round Partnership Trade': a.RodeoYearRoundPartnershiptrade,
              // 'Rodeo Local Partnership Cash': a.RodeoLocalPartnership,
              // 'Rodeo Local Partnership Trade': a.RodeoLocalPartnershiptrade,
              // 'Concert Trade': a.Concerttrade,
              // 'Community Rodeo Cash': a.CommunityRodeo,
              // 'Community Rodeo Trade': a.CommunityRodeotrade,
              // 'Royalty Cash': a.Royalty,
              // 'Royalty Trade': a.Royaltytrade,
              // 'AddOn Cash': a.AddOn,
              // 'AddOn Trade': a.AddOntrade,
              'Total Cash': a.price,
              'TotalTrade': a.trade
            }))
            // console.log(printSponsors)

            let membersWS = XLSX.utils.json_to_sheet(printSponsors)

            let wb = XLSX.utils.book_new()

            if (!wb.Props) { wb.Props = {} }
            wb.Props.Title = title

            XLSX.utils.book_append_sheet(wb, membersWS, title)

            XLSX.writeFile(wb, title + '.xlsx')
          })
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }

    // async getInvoices (payType, title) {
    //   try {
    //     const response = await Api().get('sponsors_invoices/' + this.currentYear)

    //     const acct = response.data
    //     console.log('invoices', acct)

    //     let row = {}
    //     const rows = []

    //     for (let i in acct) {
    //       let booths = ''
    //       for (let k in acct[i].VendorBooths) {
    //         booths = booths + acct[i].VendorBooths[k].boothNumber + ' '
    //       }

    //       for (let j in acct[i].VendorAccountings) {
    //         let description = ''
    //         let comma = ''
    //         let total = 0

    //         for (let k in acct[i].VendorAccountings[j].VendorAccountingDetails) {
    //           let amount = Number(acct[i].VendorAccountings[j].VendorAccountingDetails[k].quantity) * Number(acct[i].VendorAccountings[j].VendorAccountingDetails[k].price)
    //           console.log(amount)
    //           description = description + comma + acct[i].VendorAccountings[j].VendorAccountingDetails[k].description
    //           comma = ', '
    //           total = total + amount
    //         }

    //         row.name = acct[i].name
    //         row.address = acct[i].address
    //         row.city = acct[i].city
    //         row.state = acct[i].state
    //         row.zip = acct[i].zip
    //         row.fullName = acct[i].SponsorContacts[0].fullName
    //         row.email = acct[i].SponsorContacts[0].email
    //         row.phone = acct[i].SponsorContacts[0].phone
    //         row.mobile = acct[i].SponsorContacts[0].mobile
    //         row.booths = booths
    //         row.ptype = 'Invoice'
    //         row.invNo = acct[i].VendorAccountings[j].id
    //         row.notes = acct[i].VendorAccountings[j].notes
    //         row.description = description
    //         row.amount = total

    //         rows.push(row)
    //         row = {}
    //       }

    //       row = {}
    //     }

    //     let printPayments = rows.map(a => ({
    //       'Name': a.name,
    //       'Address': a.address,
    //       'City': a.city,
    //       'State': a.state,
    //       'Zip': a.zip,
    //       'Booth(s)': a.booths,
    //       'Contact': a.fullName,
    //       'Email': a.email,
    //       'Phone': a.phone,
    //       'Mobile': a.mobile,
    //       'Event': a.ptype,
    //       'Invoice No': a.invNo,
    //       'Notes': a.notes,
    //       'Description': a.description,
    //       'Amount': a.amount
    //     }))

    //     let membersWS = XLSX.utils.json_to_sheet(printPayments)

    //     let wb = XLSX.utils.book_new()

    //     if (!wb.Props) { wb.Props = {} }
    //     wb.Props.Title = title

    //     XLSX.utils.book_append_sheet(wb, membersWS, title)

    //     XLSX.writeFile(wb, title + '.xlsx')
    //   } catch (error) {
    //     this.snackbar.message = error.response.data.error
    //     this.snackbar.color = 'error'
    //     this.snackbar.show = true
    //   }
    // },

    // async getPayments (payType, title) {
    //   try {
    //     const response = await Api().get('vendors_payments/' + this.currentYear)

    //     const acct = response.data

    //     let row = {}
    //     const rows = []

    //     for (let i in acct) {
    //       let booths = ''
    //       for (let k in acct[i].VendorBooths) {
    //         booths = booths + acct[i].VendorBooths[k].boothNumber + ' '
    //       }

    //       for (let j in acct[i].VendorAccountings) {
    //         row.name = acct[i].name
    //         row.address = acct[i].address
    //         row.city = acct[i].city
    //         row.state = acct[i].state
    //         row.zip = acct[i].zip
    //         row.fullName = acct[i].SponsorContacts[0].fullName
    //         row.email = acct[i].SponsorContacts[0].email
    //         row.phone = acct[i].SponsorContacts[0].phone
    //         row.mobile = acct[i].SponsorContacts[0].mobile
    //         row.booths = booths
    //         row.ptype = 'Payment'
    //         row.payType = acct[i].VendorAccountings[j].payType
    //         row.cardName = acct[i].VendorAccountings[j].cardName
    //         row.cardNumber = acct[i].VendorAccountings[j].cardNumber
    //         row.expire = acct[i].VendorAccountings[j].expire
    //         row.cardApproval = acct[i].VendorAccountings[j].cardApproval
    //         row.amount = Number(acct[i].VendorAccountings[j].amount)
    //         row.notes = acct[i].VendorAccountings[j].notes
    //         row.taxAmount = ''
    //         row.serviceFee = ''
    //         row.cashAmount = ''
    //         row.checkAmount = ''

    //         if (acct[i].VendorAccountings[j].paymentType === 9) {
    //           row.ptype = 'Deposit'

    //           if (acct[i].VendorAccountings[j].payType === 'Credit Card') {
    //             row.taxAmount = row.amount
    //           } else if (acct[i].VendorAccountings[j].payType === 'Cash') {
    //             row.cashAmount = row.amount
    //           } else {
    //             row.checkAmount = row.amount
    //           }
    //         } else if (acct[i].VendorAccountings[j].paymentType === 23) {
    //           row.ptype = 'Sales Tax'

    //           if (acct[i].VendorAccountings[j].payType === 'Credit Card') {
    //             let taxAmount = Math.round((Number(row.amount) / 1.04 + Number.EPSILON) * 100) / 100
    //             let serviceFee = row.amount - taxAmount
    //             row.serviceFee = Math.round(serviceFee * 100) / 100
    //             row.taxAmount = Math.round(taxAmount * 100) / 100
    //           } else if (acct[i].VendorAccountings[j].payType === 'Cash') {
    //             row.cashAmount = row.amount
    //           } else {
    //             row.checkAmount = row.amount
    //           }
    //         }

    //         if (payType > 0) {
    //           if (acct[i].VendorAccountings[j].paymentType === payType) {
    //             acct[i].acct = acct[i].VendorAccountings[j]

    //             rows.push(row)
    //             row = {}
    //           }
    //         } else {
    //           rows.push(row)
    //           row = {}
    //         }
    //       }

    //       row = {}
    //     }
    //     console.log(rows)
    //     let printPayments = ''

    //     if (payType === 23) {
    //       printPayments = rows.map(a => ({
    //         'Name': a.name,
    //         'Address': a.address,
    //         'City': a.city,
    //         'State': a.state,
    //         'Zip': a.zip,
    //         'Booth(s)': a.booths,
    //         'Contact': a.fullName,
    //         'Email': a.email,
    //         'Phone': a.phone,
    //         'Mobile': a.mobile,
    //         'Event': a.ptype,
    //         'Pay Type': a.payType,
    //         'Card Name': a.cardName,
    //         'Number': a.cardNumber,
    //         'Expire': a.expire,
    //         'Approval': a.cardApproval,
    //         'Service Fee': a.serviceFee,
    //         'Credit Amount': a.taxAmount,
    //         'Check Amount': a.checkAmount,
    //         'Cash Amount': a.cashAmount,
    //         'Total': a.amount,
    //         'Notes': a.notes
    //       }))
    //     } else {
    //       printPayments = rows.map(a => ({
    //         'Name': a.name,
    //         'Address': a.address,
    //         'City': a.city,
    //         'State': a.state,
    //         'Zip': a.zip,
    //         'Booth(s)': a.booths,
    //         'Contact': a.fullName,
    //         'Email': a.email,
    //         'Phone': a.phone,
    //         'Mobile': a.mobile,
    //         'Event': a.ptype,
    //         'Pay Type': a.payType,
    //         'Card Name': a.cardName,
    //         'Number': a.cardNumber,
    //         'Expire': a.expire,
    //         'Approval': a.cardApproval,
    //         'Credit Amount': a.taxAmount,
    //         'Check Amount': a.checkAmount,
    //         'Cash Amount': a.cashAmount,
    //         'Total': a.amount,
    //         'Notes': a.notes
    //       }))
    //     }

    //     let membersWS = XLSX.utils.json_to_sheet(printPayments)

    //     let wb = XLSX.utils.book_new()

    //     if (!wb.Props) { wb.Props = {} }
    //     wb.Props.Title = title

    //     XLSX.utils.book_append_sheet(wb, membersWS, title)

    //     XLSX.writeFile(wb, title + '.xlsx')
    //   } catch (error) {
    //     this.snackbar.message = error.response.data.error
    //     this.snackbar.color = 'error'
    //     this.snackbar.show = true
    //   }
    // }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sponsor/Reports.vue